// extracted by mini-css-extract-plugin
export default {"footer":"HPPuLM","footerLeftSide":"VEMutb","likesCount":"W2FJtz","commentsCountContainer":"vdD2vZ","commentsCount":"FWOwDx","tooltip":"hiuTv5"};